'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignmentOptions", "alignment", "onChange", "menuItems"];
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import UITextToolbarIconDropdown from '../editor/UITextToolbarIconDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  alignmentOptions: PropTypes.array.isRequired,
  alignment: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  menuItems: PropTypes.array
};

// Alignment dropdown component for contextual toolbar assets
function AlignmentDropdown(props) {
  const {
      alignmentOptions,
      alignment,
      onChange,
      menuItems = []
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    // We need to render the empty dropdown once so we can calculate the
    // controlRect for toolbar responsive logic
    setMounted(true);
  }, []);
  if (mounted && !menuItems.length) {
    return null;
  }
  const handleChange = ({
    currentTarget: {
      value
    }
  }) => {
    onChange(value);
  };
  return /*#__PURE__*/_jsx(UITextToolbarIconDropdown, Object.assign({}, rest, {
    options: alignmentOptions,
    value: alignment,
    onChange: handleChange
  }));
}
AlignmentDropdown.propTypes = propTypes;
AlignmentDropdown.displayName = 'AlignmentDropdown';
export default AlignmentDropdown;